class EstablishmentLocator extends HTMLElement {
  constructor() {
    super();

    this.searchAddressInput = null;
    this.searchButton = null;
    this.items = [];
    this.filterInputs = [];
    this.noResultsMessage = null;

    this.modal = null;
    this.modalMap = null;
    this.mapWrapper = null;
    this.modalContent = null;
    this.modalContentDiv = null;

    this.modalTitle = null;
    this.modalDescription = null;

    this.addressWrapper = null;
    this.addressData = null;

    this.scheduleWrapper = null;
    this.scheduleData = null;

    this.phoneData = null;
    this.emailData = null;
    this.websiteData = null;

    this.closeModalButton = null;
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;

    this.getElements();
    this.bindEvents();
    this.updateFilterStyles();
    this.filterItems();
  }

  getElements() {
    this.searchAddressInput = this.querySelector('.search-address');
    this.searchButton = this.querySelector('.get-location');

    this.items = Array.from(
      this.querySelectorAll('.establishment-item')
    );

    this.filterInputs = Array.from(
      this.querySelectorAll('[data-type-filter]')
    );

    this.noResultsMessage = this.querySelector('.no-results');

    this.modal = this.querySelector('.punto-venta-modal');
    this.modalMap = this.querySelector('.modal-map');
    this.mapWrapper = this.querySelector('.map-wrapper');
    this.modalContent = this.querySelector('.modal-content');
    this.modalContentDiv = this.querySelector('.modal-content-div');

    this.modalTitle = this.querySelector('.modal-title');
    this.modalDescription = this.querySelector('.modal-description');

    this.addressWrapper = this.querySelector('.div-address');
    this.addressData = this.querySelector('.address-data');

    this.scheduleWrapper = this.querySelector('.div-schedule');
    this.scheduleData = this.querySelector('.schedule-data');

    this.phoneData = this.querySelector('.phone-data');
    this.emailData = this.querySelector('.email-data');
    this.websiteData = this.querySelector('.website-data');

    this.closeModalButton = this.querySelector('.close-modal-btn');
  }

  bindEvents() {
    if (this.searchAddressInput) {
      this.searchAddressInput.addEventListener(
        'input',
        this.debounce(() => {
          this.filterItems();
        }, 250)
      );

      this.searchAddressInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.filterItems();
        }
      });
    }

    if (this.searchButton) {
      this.searchButton.addEventListener('click', () => {
        this.filterItems();
      });
    }

    this.filterInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.updateFilterStyles();
        this.filterItems();
      });
    });

    this.items.forEach((item) => {
      const modalButton = item.querySelector('.js-button-modal');

      if (!modalButton) return;

      modalButton.addEventListener('click', () => {
        this.openModal(item);
      });

      modalButton.addEventListener('keydown', (event) => {
        const validKey =
          event.key === 'Enter' ||
          event.key === ' ' ||
          event.key === 'Spacebar';

        if (!validKey) return;

        event.preventDefault();
        this.openModal(item);
      });
    });

    if (this.closeModalButton) {
      this.closeModalButton.addEventListener('click', () => {
        this.closeModal();
      });
    }

    if (this.modal) {
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          this.closeModal();
        }
      });
    }

    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        this.modal &&
        !this.modal.classList.contains('tw-hidden')
      ) {
        this.closeModal();
      }
    });
  }

  getSelectedType() {
    const selectedInput = this.filterInputs.find(
      (input) => input.checked
    );

    return selectedInput ? selectedInput.value : 'fisico';
  }

  filterItems() {
  const selectedType = this.getSelectedType();

  const searchValue = this.normalizeText(
    this.searchAddressInput
      ? this.searchAddressInput.value
      : ''
  );

  let visibleItems = 0;

  this.items.forEach((item) => {
    const itemType =
      item.dataset.establishmentType || 'fisico';

    const searchableContent = this.normalizeText(
      item.dataset.establishmentSearch || ''
    );

    const matchesType =
      itemType === selectedType ||
      itemType === 'ambos';

    const matchesSearch =
      searchValue === '' ||
      searchableContent.includes(searchValue);

    const shouldShow = matchesType && matchesSearch;

    item.classList.toggle('tw-hidden', !shouldShow);

    if (shouldShow) {
      visibleItems += 1;
    }
  });

  if (this.noResultsMessage) {
    this.noResultsMessage.classList.toggle(
      'tw-hidden',
      visibleItems > 0
    );
  }
}

  updateFilterStyles() {
    const selectedType = this.getSelectedType();
    const isPhysical = selectedType === 'fisico';

    const physicalLabel = this.querySelector('.label-fisico');
    const onlineLabel = this.querySelector('.label-online');

    const physicalIcon = this.querySelector('.icon-fisico');
    const onlineIcon = this.querySelector('.icon-online');

    if (physicalIcon) {
      physicalIcon.classList.toggle('hidden', !isPhysical);
    }

    if (onlineIcon) {
      onlineIcon.classList.toggle('hidden', isPhysical);
    }

    if (physicalLabel) {
      physicalLabel.classList.toggle(
        'tw-bg-secondary',
        isPhysical
      );

      physicalLabel.classList.toggle(
        'tw-bg-secondary-soft',
        !isPhysical
      );
    }

    if (onlineLabel) {
      onlineLabel.classList.toggle(
        'tw-bg-secondary',
        !isPhysical
      );

      onlineLabel.classList.toggle(
        'tw-bg-secondary-soft',
        isPhysical
      );
    }
  }

  openModal(item) {
  if (!this.modal) return;

  const data = item.dataset;

  const name = data.establishmentName || '';
  const description = data.establishmentDescription || '';

  const address = data.establishmentAddress || '';
  const postalCode = data.establishmentCp || '';
  const province = data.establishmentProvince || '';

  const schedule = data.establishmentSchedule || '';
  const phone = data.establishmentPhone || '';
  const email = data.establishmentEmail || '';

  const mapUrl = this.getMapUrl(item);

  const websiteUrl = data.establishmentWebUrl || '';
  const websiteText =
    data.establishmentWebText ||
    websiteUrl ||
    'Visitar sitio web';

  if (this.modalTitle) {
    this.modalTitle.textContent = name;
  }

  if (this.modalDescription) {
    this.modalDescription.textContent = description;

    this.modalDescription.classList.toggle(
      'tw-hidden',
      description.trim() === ''
    );
  }

  this.renderAddress(address, postalCode, province);
  this.renderSchedule(schedule);
  this.renderPhone(phone);
  this.renderEmail(email);
  this.renderWebsite(websiteUrl, websiteText);
  this.renderMap(mapUrl);

  this.modal.classList.remove('tw-hidden');
  this.modal.setAttribute('aria-hidden', 'false');

  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
}

  renderAddress(address, postalCode, province) {
    if (!this.addressWrapper || !this.addressData) return;

    const addressParts = [
      address.trim(),
      postalCode.trim(),
      province.trim()
    ].filter(Boolean);

    const fullAddress = addressParts.join(', ');

    this.addressData.textContent = fullAddress;

    this.addressWrapper.classList.toggle(
      'tw-hidden',
      fullAddress === ''
    );
  }

  renderSchedule(schedule) {
    if (!this.scheduleWrapper || !this.scheduleData) return;

    const cleanSchedule = schedule.trim();

    this.scheduleData.textContent = cleanSchedule;

    this.scheduleWrapper.classList.toggle(
      'tw-hidden',
      cleanSchedule === ''
    );
  }

  renderPhone(phone) {
    if (!this.phoneData) return;

    this.phoneData.innerHTML = '';

    const cleanPhone = phone.trim();

    if (cleanPhone === '') return;

    const link = document.createElement('a');

    link.href = `tel:${cleanPhone.replace(/[^\d+]/g, '')}`;
    link.className =
      'tw-text-sm xl:tw-text-xl tw-font-light';
    link.textContent = cleanPhone;

    this.phoneData.appendChild(link);
  }

  renderEmail(email) {
    if (!this.emailData) return;

    this.emailData.innerHTML = '';

    const cleanEmail = email.trim();

    if (cleanEmail === '') return;

    const link = document.createElement('a');

    link.href = `mailto:${cleanEmail}`;
    link.className =
      'tw-text-sm xl:tw-text-xl tw-font-semibold tw-underline';
    link.textContent = cleanEmail;

    this.emailData.appendChild(link);
  }

  renderWebsite(websiteUrl, websiteText) {
    if (!this.websiteData) return;

    this.websiteData.innerHTML = '';

    const cleanUrl = websiteUrl.trim();

    if (cleanUrl === '') return;

    const link = document.createElement('a');

    link.href = cleanUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.className =
      'tw-text-sm xl:tw-text-xl tw-font-semibold tw-underline';
    link.textContent = websiteText;

    this.websiteData.appendChild(link);
  }

  getMapUrl(item) {
    const mapTemplate = item.querySelector(
      '.establishment-map-template'
    );

    if (!mapTemplate) return '';

    /*
    * Cuando el contenido está dentro de un <template>,
    * sus elementos se encuentran en la propiedad content.
    */
    const iframe = mapTemplate.content
      ? mapTemplate.content.querySelector('iframe')
      : null;

    if (!iframe) return '';

    return iframe.getAttribute('src') || '';
  }

  renderMap(mapUrl) {
    if (
      !this.modalMap ||
      !this.mapWrapper ||
      !this.modalContent
    ) {
      return;
    }

    const hasMap = mapUrl.trim() !== '';

    this.modalMap.src = hasMap ? mapUrl : '';

    this.mapWrapper.classList.toggle(
      'tw-hidden',
      !hasMap
    );

    this.modalContent.classList.toggle(
      'xl:tw-grid-cols-2',
      hasMap
    );

    this.modalContent.classList.toggle(
      'xl:tw-grid-cols-1',
      !hasMap
    );

    if (this.modalContentDiv) {
      this.modalContentDiv.classList.toggle(
        'xl:tw-order-2',
        hasMap
      );
    }
  }

  closeModal() {
    if (!this.modal) return;

    this.modal.classList.add('tw-hidden');
    this.modal.setAttribute('aria-hidden', 'true');

    if (this.modalMap) {
      this.modalMap.src = '';
    }

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  debounce(callback, delay = 250) {
    let timeout;

    return (...args) => {
      window.clearTimeout(timeout);

      timeout = window.setTimeout(() => {
        callback.apply(this, args);
      }, delay);
    };
  }
}

if (!customElements.get('establishment-locator')) {
  customElements.define(
    'establishment-locator',
    EstablishmentLocator
  );
}